var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar_wrapper",style:(_vm.style)},[(_vm.src)?_c('img',{style:(_vm.style),attrs:{"src":_vm.src}}):_c('img',{style:(_vm.style),attrs:{"src":require("@/components/icons/user.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }